import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-all-orders',
  standalone: true,
  imports: [NgFor, CommonModule, FormsModule],
  templateUrl: './all-orders.component.html',
  styleUrls: ['./all-orders.component.css']
})
export class AllOrdersComponent {
  @Input() orders: any[] = [];
  @Output() orderUpdated = new EventEmitter<any>();

  isModalOpen = false;
  selectedOrder: any = null;
  quantityForApproval: number | null = null;
  maxApprovableQuantity = 0;
  errorPopupVisible = false;
  errorValidQtyPopupVisible = false;

  openApprovalModal(order: any): void {
    console.log('Opening approval modal for order:', order);
    this.selectedOrder = { ...order };
    this.maxApprovableQuantity =
      Number(order.quantity) -
      (Number(order.ready_quantity) + Number(order.approved_quantity));

    this.quantityForApproval = null;
    this.isModalOpen = true;
  }

  closeModal(): void {
    this.isModalOpen = false;
    this.selectedOrder = null;
    this.quantityForApproval = null;
  }

  submitForApproval(): void {
    if (!this.selectedOrder || this.quantityForApproval === null || this.quantityForApproval <= 0) {
      this.errorValidQtyPopupVisible = true;
      return;
    }

    if (this.quantityForApproval > this.maxApprovableQuantity) {
      this.errorPopupVisible = true;
      return;
    }

    const newReadyQty = Number(this.selectedOrder.ready_quantity) + Number(this.quantityForApproval);

    const updatedData = {
      orderId: this.selectedOrder.id,
      ready_quantity: newReadyQty,
      ordc_request_status: 'approval_waiting',
    };

    console.log('Updated order data:', updatedData);

    this.orderUpdated.emit(updatedData);
    this.closeModal();
  }
}
